import React from "react";
import { useLocation, Routes, Route, Navigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useAuth } from "../auth/AuthContext";
import Navbar from "components/Navbars/Navbar";
import AdminFooter from "components/Footers/AdminFooter";
import Sidebar from "components/Sidebar/Sidebar";
import MobileSidebarNav from "components/Sidebar/MobileSidebarNav";
import { useRoutes } from "routes";

// helper
const flattenRoutes = (rs, { includeHidden = false } = {}) =>
  (Array.isArray(rs) ? rs : [])
    .flatMap((r) =>
      r?.children
        ? r.children.filter((c) => includeHidden || !c.hidden)
        : includeHidden || !r?.hidden
          ? [r]
          : [],
    )
    .filter((r) => r?.path);

const User = () => {
  const routes = useRoutes();
  const mainContent = React.useRef(null);
  const location = useLocation();

  const { user } = useAuth();
  const role = (
    user?.role ||
    localStorage.getItem("role") ||
    "user"
  ).toLowerCase();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  // routes สำหรับลงทะเบียน (รวม hidden)
  const allRoutes = React.useMemo(
    () =>
      flattenRoutes(routes, { includeHidden: true }).filter(
        (r) => !r.roles || r.roles.includes(role),
      ),
    [routes, role],
  );

  const visibleRoutes = React.useMemo(
    () =>
      flattenRoutes(routes, { includeHidden: false }).filter(
        (r) => !r.roles || r.roles.includes(role),
      ),
    [routes, role],
  );

  const getBrandText = (pathname) => {
    const found = (visibleRoutes || []).find((r) =>
      pathname.startsWith(r.path),
    );
    return found?.name || "หน้าแรก";
  };

  const logo = {
    innerLink: "/customer-report",
    imgSrc: require("../assets/img/brand/logo.png"),
    imgAlt: "Logo",
  };

  return (
    <>
      <Sidebar routes={routes} logo={logo} />
      <MobileSidebarNav routes={routes} logo={logo} />

      <div className="main-content" ref={mainContent}>
        <Navbar brandText={getBrandText(location.pathname)} />

        <Routes>
          {/* ✅ เข้า layout แล้วให้ไป customer-report ทันที */}
          <Route
            path="/"
            element={<Navigate to="/customer-report" replace />}
          />
          {allRoutes.map((r, i) => (
            <Route key={i} path={r.path} element={r.component} />
          ))}
          {/* ✅ ถ้าเข้า path แปลกๆ ให้กลับไป index */}
          <Route path="*" element={<Navigate to="/customer-report" replace />} />
          {/* ✅ ถ้าเข้า path แปลกๆ ให้กลับไป customer-report */}
          <Route
            path="*"
            element={<Navigate to="/customer-report" replace />}
          />
        </Routes>

        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default User;
